import { getVisibleArrows } from './utils/get-visible-arrows.js';
import { PanningControls } from '../../../core/components/axes/components/PanningControls/PanningControls.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import type { XYChartAxisInternal } from '../../types/xy-chart-internals.js';

interface XYChartPanningControlsProps {
  onClickPan: (domain: number) => void;
  visibleAxis: XYChartAxisInternal;
}

export const XYChartPanningControls = (props: XYChartPanningControlsProps) => {
  const { onClickPan, visibleAxis } = props;

  const scales = useXYChartScales();
  const { axes } = useXYChartData();

  const [left, right] = getVisibleArrows(visibleAxis, scales, axes);

  return (
    <PanningControls
      onClickPan={onClickPan}
      showLeftControl={left}
      showRightControl={right}
    />
  );
};
